/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignUp_viewer = {
    readonly id: string;
    readonly username: string | null;
    readonly " $refType": "SignUp_viewer";
};
export type SignUp_viewer$data = SignUp_viewer;
export type SignUp_viewer$key = {
    readonly " $data"?: SignUp_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SignUp_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SignUp_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '3e55bdb5db50933de88b6ffd3b9667b4';
export default node;
